var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDoubleUnderline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7901 13.95C10.8201 13.56 13.0001 10.84 13.0001 7.79V1.25C13.0001 0.56 12.4401 0 11.7501 0C11.0601 0 10.5001 0.56 10.5001 1.25V7.9C10.5001 9.57 9.3701 11.09 7.7301 11.42C5.4801 11.89 3.5001 10.17 3.5001 8V1.25C3.5001 0.56 2.9401 0 2.2501 0C1.5601 0 1.0001 0.56 1.0001 1.25V8C1.0001 11.57 4.1301 14.42 7.7901 13.95ZM9.875e-05 16C9.875e-05 16.55 0.450099 17 1.0001 17H13.0001C13.5501 17 14.0001 16.55 14.0001 16C14.0001 15.45 13.5501 15 13.0001 15H1.0001C0.450099 15 9.875e-05 15.45 9.875e-05 16Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20C0.45 20 0 19.55 0 19C0 18.45 0.45 18 1 18H13C13.55 18 14 18.45 14 19C14 19.55 13.55 20 13 20H1Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoubleUnderline);
export default __webpack_public_path__ + "static/media/icon_double_underline.7df9ff838cfc34b8ff185cba4cdfba6b.svg";
export { ForwardRef as ReactComponent };